import { SearchTextfield } from '@brandfolder/react';

import { t } from '@lingui/macro';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { PeopleTagsDropdown } from '../common/PeopleTagsDropdown';
import { FilterValues, PeoplePageParamKeys } from '../customPeopleTagTypes';
import { usePeoplePageSearchState } from '../hooks/usePeoplePageQueryState';

const PeopleActionsBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content:flex-end;
  padding-bottom: 16px;

  @media (min-width: 900px) {
    flex-direction: row;
  }
`;

const SearchPeopleTextfield = styled(SearchTextfield)`
  @media (min-width: 900px) {
    width: 50%;
  }
`;

const ActionBarDropdownWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 0;

  .filter-people-dropdown,
  .sort-people-dropdown {
    position: relative;
    width: 48.5%;
  }

  .dropdown-button {
    width: 100%;
  }

  @media (min-width: 744px) {
    .filter-people-dropdown {
      margin-right: 10px;
      width: 30%;
    }
    .sort-people-dropdown {
      margin-left: 10px;
      width: 70%;
    }
  }

  @media (min-width: 900px) {
    margin: 0 0 20px 20px;
    width: 48.5%;
  }

  @media (min-width: 1526px) {
    .filter-people-dropdown {
      width: 30%;
    }
    .sort-people-dropdown {
      width: 70%;
    }
  }
`;

interface PeoplePageActionsBarProps {
  hasTaggedFaces?: boolean;
}
export const PeoplePageActionsBar: FunctionComponent<PeoplePageActionsBarProps> = ({
  hasTaggedFaces = true
}) => {
  const [state, setState] = usePeoplePageSearchState();
  const showSearchBar = hasTaggedFaces && state.filter !== FilterValues.Untagged && !!state.filter;

  const setSortByState = (key: string): void => {
    setState({ [PeoplePageParamKeys.Sort]: key });
  };

  const setFilterByState = (key: string): void => {
    setState({ [PeoplePageParamKeys.Filter]: key });
  };

  return (
    <PeopleActionsBarWrapper>
      <SearchPeopleTextfield
        className={showSearchBar ? 'visible' : 'hidden'}
        id="search-textfield"
        label="Search for people textfield"
        onChange={(e): void => setState({ [PeoplePageParamKeys.Search]: e.target.value })}
        placeholder={t`Search for people`}
        showLabel={false}
        value={state.search || ''}
      />
      <ActionBarDropdownWrapper>
        <PeopleTagsDropdown
          selectedValue={state.filter}
          setSelectedValue={setFilterByState}
          type="filter"
        />
        <PeopleTagsDropdown
          selectedValue={state.sort}
          setSelectedValue={setSortByState}
          type="sort"
        />
      </ActionBarDropdownWrapper>
    </PeopleActionsBarWrapper>
  );
};
